import { FC } from 'react';
import { cn, nFormatter } from 'src/utils/utility';
import { CustomTooltip } from 'src/presentations/components/atom/customtooltip';
import { CardAnalyticContent } from './CardAnalyticContent';
import { ICardAnalyticItemProps } from './types';

interface CardTableAnalyticProps {
  item: ICardAnalyticItemProps;
  isLoading: boolean;
  hasError?: boolean;
  filterCount?: number;
  filterValue?: string;
}

export const CardTableAnalytic: FC<CardTableAnalyticProps> = ({ item, isLoading, hasError, filterCount = 0, filterValue }) => {
  // Determine the display value based on filter state
  const displayValue = filterCount > 0 ? item.filteredCount || filterValue : item.count;

  // Parse the display value to check if it's a number
  let numericValue: number = 0;
  let isNumeric = false;

  if (typeof displayValue === 'string') {
    numericValue = parseFloat(displayValue.replace(/,/g, ''));
    isNumeric = !isNaN(numericValue);
  } else if (typeof displayValue === 'number') {
    numericValue = displayValue;
    isNumeric = true;
  }

  // Format large numbers with K/M suffixes
  const formattedValue = isNumeric && numericValue >= 1000 ? nFormatter(numericValue, 1) : displayValue;
  const showTooltip = isNumeric && numericValue >= 1000;

  return (
    <CardAnalyticContent
      item={item}
      isLoading={isLoading}
      readOnly={true} // FORCED: Table variant is always read-only
      isEnable={true} // Always enabled for display
      isActive={false} // Never active (no selection)
      hasError={hasError}
    >
      {/* Filter Statistics - Always shown in table view */}
      <div className='flex items-center gap-[5px] text-[12px] font-["Roboto"]'>
        <span className='text-neutral-60'>
          {filterCount} Table Filter{filterCount !== 1 ? 's' : ''}:
        </span>
        {showTooltip ? (
          <CustomTooltip title={numericValue.toLocaleString()}>
            <span className='text-neutral-90 font-medium'>{formattedValue}</span>
          </CustomTooltip>
        ) : (
          <span className='text-neutral-90 font-medium'>{formattedValue}</span>
        )}
      </div>
    </CardAnalyticContent>
  );
};
